<template>
  <Info :showSigninLink="true">
    Your email address is not verified. An email was recently sent<br />
    to you, please check your inbox (and possibly Spam folder) for the<br />
    email to complete the sign-up process and then sign in again.
  </Info>
</template>

<script>
export default {
  name: "EmailVerification",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
};
</script>

<style scoped></style>
